<template>
    <EditOffre />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import EditOffre from "@/components/Offre/EditOffre.vue";
  
    export default defineComponent({
      name: "EditOffrePage",
      components: {
        
        EditOffre,
      },
    });
  </script>